import {
  HttpRequestAdapter,
  requestFunctionBuilder,
} from "@kanda-libs/openapi-io-ts-runtime";
import {
  acceptedJobSummaryLeadOperation,
  AcceptedJobSummaryLeadRequestFunction,
} from "./acceptedJobSummaryLead";
import {
  actionAdhocOperation,
  ActionAdhocRequestFunction,
} from "./actionAdhoc";
import {
  actionIntroductionOperation,
  ActionIntroductionRequestFunction,
} from "./actionIntroduction";
import {
  applyCreditOperation,
  ApplyCreditRequestFunction,
} from "./applyCredit";
import {
  applyInviteLeadOperation,
  ApplyInviteLeadRequestFunction,
} from "./applyInviteLead";
import { applyJobOperation, ApplyJobRequestFunction } from "./applyJob";
import {
  approveCompanyOperation,
  ApproveCompanyRequestFunction,
} from "./approveCompany";
import {
  approveJobSatNoteOperation,
  ApproveJobSatNoteRequestFunction,
} from "./approveJobSatNote";
import { archiveJobOperation, ArchiveJobRequestFunction } from "./archiveJob";
import { budgetLeadOperation, BudgetLeadRequestFunction } from "./budgetLead";
import {
  checkCreditOperation,
  CheckCreditRequestFunction,
} from "./checkCredit";
import { checkJobOperation, CheckJobRequestFunction } from "./checkJob";
import {
  completeJobOperation,
  CompleteJobRequestFunction,
} from "./completeJob";
import {
  connectTradesLeadOperation,
  ConnectTradesLeadRequestFunction,
} from "./connectTradesLead";
import {
  consentMigrateCreditOperation,
  ConsentMigrateCreditRequestFunction,
} from "./consentMigrateCredit";
import {
  declineCompanyOperation,
  DeclineCompanyRequestFunction,
} from "./declineCompany";
import {
  delayJobSatNoteOperation,
  DelayJobSatNoteRequestFunction,
} from "./delayJobSatNote";
import {
  deleteCompanyOperation,
  DeleteCompanyRequestFunction,
} from "./deleteCompany";
import {
  deleteCreditOperation,
  DeleteCreditRequestFunction,
} from "./deleteCredit";
import {
  deleteDocumentOperation,
  DeleteDocumentRequestFunction,
} from "./deleteDocument";
import {
  deleteEnquiryOperation,
  DeleteEnquiryRequestFunction,
} from "./deleteEnquiry";
import {
  deleteEnterpriseOperation,
  DeleteEnterpriseRequestFunction,
} from "./deleteEnterprise";
import {
  deleteIntroductionOperation,
  DeleteIntroductionRequestFunction,
} from "./deleteIntroduction";
import { deleteJobOperation, DeleteJobRequestFunction } from "./deleteJob";
import { deleteLeadOperation, DeleteLeadRequestFunction } from "./deleteLead";
import {
  deleteMonitorOperation,
  DeleteMonitorRequestFunction,
} from "./deleteMonitor";
import {
  deleteOnboardingOperation,
  DeleteOnboardingRequestFunction,
} from "./deleteOnboarding";
import {
  deletePartnerOperation,
  DeletePartnerRequestFunction,
} from "./deletePartner";
import {
  deletePaymentOperation,
  DeletePaymentRequestFunction,
} from "./deletePayment";
import { deleteRateOperation, DeleteRateRequestFunction } from "./deleteRate";
import {
  deleteSubscriptionOperation,
  DeleteSubscriptionRequestFunction,
} from "./deleteSubscription";
import { deleteTagOperation, DeleteTagRequestFunction } from "./deleteTag";
import {
  deleteTrainingOperation,
  DeleteTrainingRequestFunction,
} from "./deleteTraining";
import {
  deleteTransactionOperation,
  DeleteTransactionRequestFunction,
} from "./deleteTransaction";
import {
  directorCompanyOperation,
  DirectorCompanyRequestFunction,
} from "./directorCompany";
import {
  exportEnterpriseDailyReportOperation,
  ExportEnterpriseDailyReportRequestFunction,
} from "./exportEnterpriseDailyReport";
import {
  exportFcaApprovedOperation,
  ExportFcaApprovedRequestFunction,
} from "./exportFcaApproved";
import {
  exportJobPayoutsOperation,
  ExportJobPayoutsRequestFunction,
} from "./exportJobPayouts";
import { getAuditOperation, GetAuditRequestFunction } from "./getAudit";
import { getAuditsOperation, GetAuditsRequestFunction } from "./getAudits";
import {
  getCompaniesOperation,
  GetCompaniesRequestFunction,
} from "./getCompanies";
import { getCompanyOperation, GetCompanyRequestFunction } from "./getCompany";
import {
  getCompanyDirectorVerificationOperation,
  GetCompanyDirectorVerificationRequestFunction,
} from "./getCompanyDirectorVerification";
import {
  getCompanyReferralsOperation,
  GetCompanyReferralsRequestFunction,
} from "./getCompanyReferrals";
import { getCreditOperation, GetCreditRequestFunction } from "./getCredit";
import { getCreditsOperation, GetCreditsRequestFunction } from "./getCredits";
import {
  getDocumentOperation,
  GetDocumentRequestFunction,
} from "./getDocument";
import {
  getDocumentsOperation,
  GetDocumentsRequestFunction,
} from "./getDocuments";
import {
  getEnquiriesOperation,
  GetEnquiriesRequestFunction,
} from "./getEnquiries";
import { getEnquiryOperation, GetEnquiryRequestFunction } from "./getEnquiry";
import {
  getEnrolmentOperation,
  GetEnrolmentRequestFunction,
} from "./getEnrolment";
import {
  getEnrolmentsOperation,
  GetEnrolmentsRequestFunction,
} from "./getEnrolments";
import {
  getEnterpriseOperation,
  GetEnterpriseRequestFunction,
} from "./getEnterprise";
import {
  getEnterpriseBranchesOperation,
  GetEnterpriseBranchesRequestFunction,
} from "./getEnterpriseBranches";
import {
  getEnterprisesOperation,
  GetEnterprisesRequestFunction,
} from "./getEnterprises";
import {
  getInfoEnquiryOperation,
  GetInfoEnquiryRequestFunction,
} from "./getInfoEnquiry";
import {
  getInfoEntityOperation,
  GetInfoEntityRequestFunction,
} from "./getInfoEntity";
import {
  getIntroductionOperation,
  GetIntroductionRequestFunction,
} from "./getIntroduction";
import {
  getIntroductionsOperation,
  GetIntroductionsRequestFunction,
} from "./getIntroductions";
import { getJobOperation, GetJobRequestFunction } from "./getJob";
import { getJobsOperation, GetJobsRequestFunction } from "./getJobs";
import { getLeadOperation, GetLeadRequestFunction } from "./getLead";
import { getLeadsOperation, GetLeadsRequestFunction } from "./getLeads";
import { getMonitorOperation, GetMonitorRequestFunction } from "./getMonitor";
import {
  getMonitorsOperation,
  GetMonitorsRequestFunction,
} from "./getMonitors";
import {
  getOnboardingOperation,
  GetOnboardingRequestFunction,
} from "./getOnboarding";
import {
  getOnboardingsOperation,
  GetOnboardingsRequestFunction,
} from "./getOnboardings";
import { getPartnerOperation, GetPartnerRequestFunction } from "./getPartner";
import {
  getPartnersOperation,
  GetPartnersRequestFunction,
} from "./getPartners";
import { getPaymentOperation, GetPaymentRequestFunction } from "./getPayment";
import {
  getPaymentsOperation,
  GetPaymentsRequestFunction,
} from "./getPayments";
import { getRateOperation, GetRateRequestFunction } from "./getRate";
import { getRatesOperation, GetRatesRequestFunction } from "./getRates";
import {
  getSubscriptionOperation,
  GetSubscriptionRequestFunction,
} from "./getSubscription";
import {
  getSubscriptionsOperation,
  GetSubscriptionsRequestFunction,
} from "./getSubscriptions";
import { getTagOperation, GetTagRequestFunction } from "./getTag";
import { getTagsOperation, GetTagsRequestFunction } from "./getTags";
import {
  getTrainingOperation,
  GetTrainingRequestFunction,
} from "./getTraining";
import {
  getTrainingsOperation,
  GetTrainingsRequestFunction,
} from "./getTrainings";
import {
  getTransactionOperation,
  GetTransactionRequestFunction,
} from "./getTransaction";
import {
  getTransactionsOperation,
  GetTransactionsRequestFunction,
} from "./getTransactions";
import {
  importFcaApprovedOperation,
  ImportFcaApprovedRequestFunction,
} from "./importFcaApproved";
import { infoAuthOperation, InfoAuthRequestFunction } from "./infoAuth";
import {
  infoCampaignOperation,
  InfoCampaignRequestFunction,
} from "./infoCampaign";
import {
  infoCheckoutRedirectOperation,
  InfoCheckoutRedirectRequestFunction,
} from "./infoCheckoutRedirect";
import {
  infoClaimAccountOperation,
  InfoClaimAccountRequestFunction,
} from "./infoClaimAccount";
import {
  infoCompanyOperation,
  InfoCompanyRequestFunction,
} from "./infoCompany";
import { infoCreditOperation, InfoCreditRequestFunction } from "./infoCredit";
import {
  infoCustomerOperation,
  InfoCustomerRequestFunction,
} from "./infoCustomer";
import {
  infoDeleteCacheOperation,
  InfoDeleteCacheRequestFunction,
} from "./infoDeleteCache";
import {
  infoDirectorOperation,
  InfoDirectorRequestFunction,
} from "./infoDirector";
import {
  infoEnterpriseOperation,
  InfoEnterpriseRequestFunction,
} from "./infoEnterprise";
import {
  infoEnterpriseRoleOperation,
  InfoEnterpriseRoleRequestFunction,
} from "./infoEnterpriseRole";
import {
  infoExampleJobOperation,
  InfoExampleJobRequestFunction,
} from "./infoExampleJob";
import {
  infoGetCacheOperation,
  InfoGetCacheRequestFunction,
} from "./infoGetCache";
import { infoGhostOperation, InfoGhostRequestFunction } from "./infoGhost";
import { infoHealthOperation, InfoHealthRequestFunction } from "./infoHealth";
import {
  infoIntroductionStatsOperation,
  InfoIntroductionStatsRequestFunction,
} from "./infoIntroductionStats";
import { infoIPOperation, InfoIPRequestFunction } from "./infoIP";
import { infoLeadOperation, InfoLeadRequestFunction } from "./infoLead";
import {
  infoLegacyRedirectOperation,
  InfoLegacyRedirectRequestFunction,
} from "./infoLegacyRedirect";
import {
  infoOnboardingOperation,
  InfoOnboardingRequestFunction,
} from "./infoOnboarding";
import {
  infoPartnerBrandingOperation,
  InfoPartnerBrandingRequestFunction,
} from "./infoPartnerBranding";
import {
  infoPasswordOperation,
  InfoPasswordRequestFunction,
} from "./infoPassword";
import {
  infoPutCacheOperation,
  InfoPutCacheRequestFunction,
} from "./infoPutCache";
import { infoQueryOperation, InfoQueryRequestFunction } from "./infoQuery";
import { infoRateOperation, InfoRateRequestFunction } from "./infoRate";
import {
  infoRelationOperation,
  InfoRelationRequestFunction,
} from "./infoRelation";
import { infoSearchOperation, InfoSearchRequestFunction } from "./infoSearch";
import {
  infoSessionOperation,
  InfoSessionRequestFunction,
} from "./infoSession";
import { infoStatsOperation, InfoStatsRequestFunction } from "./infoStats";
import {
  infoTradeSummaryOperation,
  InfoTradeSummaryRequestFunction,
} from "./infoTradeSummary";
import {
  infoValidateEmailOperation,
  InfoValidateEmailRequestFunction,
} from "./infoValidateEmail";
import { infoVerifyOperation, InfoVerifyRequestFunction } from "./infoVerify";
import {
  infoWorkTypeOperation,
  InfoWorkTypeRequestFunction,
} from "./infoWorkType";
import {
  jobCheckoutLinkOperation,
  JobCheckoutLinkRequestFunction,
} from "./jobCheckoutLink";
import {
  jobCompanyInfoOperation,
  JobCompanyInfoRequestFunction,
} from "./jobCompanyInfo";
import {
  lenderReviewJobSatNoteOperation,
  LenderReviewJobSatNoteRequestFunction,
} from "./lenderReviewJobSatNote";
import {
  markPaymentOperation,
  MarkPaymentRequestFunction,
} from "./markPayment";
import {
  matchTradesLeadOperation,
  MatchTradesLeadRequestFunction,
} from "./matchTradesLead";
import { meOperation, MeRequestFunction } from "./me";
import {
  migrateCreditOperation,
  MigrateCreditRequestFunction,
} from "./migrateCredit";
import {
  overrideJobOperation,
  OverrideJobRequestFunction,
} from "./overrideJob";
import { payJobOperation, PayJobRequestFunction } from "./payJob";
import { payoutJobOperation, PayoutJobRequestFunction } from "./payoutJob";
import { payoutsJobOperation, PayoutsJobRequestFunction } from "./payoutsJob";
import {
  pendingSubscriptionOperation,
  PendingSubscriptionRequestFunction,
} from "./pendingSubscription";
import { postAuditOperation, PostAuditRequestFunction } from "./postAudit";
import {
  postCompanyOperation,
  PostCompanyRequestFunction,
} from "./postCompany";
import {
  postCompanyBillingOperation,
  PostCompanyBillingRequestFunction,
} from "./postCompanyBilling";
import {
  postCompanyBillingSuccessOperation,
  PostCompanyBillingSuccessRequestFunction,
} from "./postCompanyBillingSuccess";
import {
  postCompanyDirectorVerificationOperation,
  PostCompanyDirectorVerificationRequestFunction,
} from "./postCompanyDirectorVerification";
import {
  postCompanyReferralsOperation,
  PostCompanyReferralsRequestFunction,
} from "./postCompanyReferrals";
import { postCreditOperation, PostCreditRequestFunction } from "./postCredit";
import {
  postDocumentOperation,
  PostDocumentRequestFunction,
} from "./postDocument";
import {
  postEnquiryOperation,
  PostEnquiryRequestFunction,
} from "./postEnquiry";
import {
  postEnquiryArchiveOperation,
  PostEnquiryArchiveRequestFunction,
} from "./postEnquiryArchive";
import {
  postEnquiryBudgetOperation,
  PostEnquiryBudgetRequestFunction,
} from "./postEnquiryBudget";
import {
  postEnquiryConsumerOperation,
  PostEnquiryConsumerRequestFunction,
} from "./postEnquiryConsumer";
import {
  postEnquiryConsumerPreferencesOperation,
  PostEnquiryConsumerPreferencesRequestFunction,
} from "./postEnquiryConsumerPreferences";
import {
  postEnquiryConsumerSignatureOperation,
  PostEnquiryConsumerSignatureRequestFunction,
} from "./postEnquiryConsumerSignature";
import {
  postEnquiryConvertJobOperation,
  PostEnquiryConvertJobRequestFunction,
} from "./postEnquiryConvertJob";
import {
  postEnquiryInterestInCreditOperation,
  PostEnquiryInterestInCreditRequestFunction,
} from "./postEnquiryInterestInCredit";
import {
  postEnquiryJobInfoOperation,
  PostEnquiryJobInfoRequestFunction,
} from "./postEnquiryJobInfo";
import {
  postEnquiryQuoteOperation,
  PostEnquiryQuoteRequestFunction,
} from "./postEnquiryQuote";
import {
  postEnquiryStateOperation,
  PostEnquiryStateRequestFunction,
} from "./postEnquiryState";
import {
  postEnquirySubmitOperation,
  PostEnquirySubmitRequestFunction,
} from "./postEnquirySubmit";
import {
  postEnquiryUnarchiveOperation,
  PostEnquiryUnarchiveRequestFunction,
} from "./postEnquiryUnarchive";
import {
  postEnterpriseOperation,
  PostEnterpriseRequestFunction,
} from "./postEnterprise";
import {
  postEnterpriseBranchesOperation,
  PostEnterpriseBranchesRequestFunction,
} from "./postEnterpriseBranches";
import { postEventOperation, PostEventRequestFunction } from "./postEvent";
import {
  postIntroductionOperation,
  PostIntroductionRequestFunction,
} from "./postIntroduction";
import {
  postIntroductionAmendJobDetailsOperation,
  PostIntroductionAmendJobDetailsRequestFunction,
} from "./postIntroductionAmendJobDetails";
import {
  postIntroductionConsumerApplyOperation,
  PostIntroductionConsumerApplyRequestFunction,
} from "./postIntroductionConsumerApply";
import {
  postIntroductionConsumerBudgetsOperation,
  PostIntroductionConsumerBudgetsRequestFunction,
} from "./postIntroductionConsumerBudgets";
import {
  postIntroductionConsumerDetailsOperation,
  PostIntroductionConsumerDetailsRequestFunction,
} from "./postIntroductionConsumerDetails";
import {
  postIntroductionConsumerSignatureOperation,
  PostIntroductionConsumerSignatureRequestFunction,
} from "./postIntroductionConsumerSignature";
import {
  postIntroductionConvertJobOperation,
  PostIntroductionConvertJobRequestFunction,
} from "./postIntroductionConvertJob";
import {
  postIntroductionJobDetailsOperation,
  PostIntroductionJobDetailsRequestFunction,
} from "./postIntroductionJobDetails";
import {
  postIntroductionNotificationOperation,
  PostIntroductionNotificationRequestFunction,
} from "./postIntroductionNotification";
import {
  postIntroductionRejectJobOperation,
  PostIntroductionRejectJobRequestFunction,
} from "./postIntroductionRejectJob";
import {
  postIntroductionTraderOperation,
  PostIntroductionTraderRequestFunction,
} from "./postIntroductionTrader";
import {
  postIntroductionTraderApproveAmendedOperation,
  PostIntroductionTraderApproveAmendedRequestFunction,
} from "./postIntroductionTraderApproveAmended";
import {
  postIntroductionTraderDetailsOperation,
  PostIntroductionTraderDetailsRequestFunction,
} from "./postIntroductionTraderDetails";
import {
  postIntroductionTraderSignatureOperation,
  PostIntroductionTraderSignatureRequestFunction,
} from "./postIntroductionTraderSignature";
import { postJobOperation, PostJobRequestFunction } from "./postJob";
import { postLeadOperation, PostLeadRequestFunction } from "./postLead";
import { postMeOperation, PostMeRequestFunction } from "./postMe";
import {
  postMonitorOperation,
  PostMonitorRequestFunction,
} from "./postMonitor";
import {
  postMonitorFlagOperation,
  PostMonitorFlagRequestFunction,
} from "./postMonitorFlag";
import {
  postOnboardingOperation,
  PostOnboardingRequestFunction,
} from "./postOnboarding";
import {
  postOnboardingDecisionOperation,
  PostOnboardingDecisionRequestFunction,
} from "./postOnboardingDecision";
import {
  postPartnerOperation,
  PostPartnerRequestFunction,
} from "./postPartner";
import {
  postPartnerReferralsOperation,
  PostPartnerReferralsRequestFunction,
} from "./postPartnerReferrals";
import {
  postPaymentOperation,
  PostPaymentRequestFunction,
} from "./postPayment";
import { postRateOperation, PostRateRequestFunction } from "./postRate";
import {
  postSubscriptionOperation,
  PostSubscriptionRequestFunction,
} from "./postSubscription";
import { postTagOperation, PostTagRequestFunction } from "./postTag";
import {
  postTrainingOperation,
  PostTrainingRequestFunction,
} from "./postTraining";
import {
  postTransactionOperation,
  PostTransactionRequestFunction,
} from "./postTransaction";
import {
  providerCheckWebhookOperation,
  ProviderCheckWebhookRequestFunction,
} from "./providerCheckWebhook";
import {
  providerWebhookOperation,
  ProviderWebhookRequestFunction,
} from "./providerWebhook";
import { putCompanyOperation, PutCompanyRequestFunction } from "./putCompany";
import { putCreditOperation, PutCreditRequestFunction } from "./putCredit";
import {
  putDocumentOperation,
  PutDocumentRequestFunction,
} from "./putDocument";
import { putEnquiryOperation, PutEnquiryRequestFunction } from "./putEnquiry";
import {
  putEnrolmentOperation,
  PutEnrolmentRequestFunction,
} from "./putEnrolment";
import {
  putEnterpriseOperation,
  PutEnterpriseRequestFunction,
} from "./putEnterprise";
import {
  putInfoStatsOperation,
  PutInfoStatsRequestFunction,
} from "./putInfoStats";
import { putInfoTagOperation, PutInfoTagRequestFunction } from "./putInfoTag";
import {
  putIntroductionOperation,
  PutIntroductionRequestFunction,
} from "./putIntroduction";
import { putJobOperation, PutJobRequestFunction } from "./putJob";
import { putLeadOperation, PutLeadRequestFunction } from "./putLead";
import { putMeOperation, PutMeRequestFunction } from "./putMe";
import { putMonitorOperation, PutMonitorRequestFunction } from "./putMonitor";
import {
  putOnboardingOperation,
  PutOnboardingRequestFunction,
} from "./putOnboarding";
import { putPartnerOperation, PutPartnerRequestFunction } from "./putPartner";
import { putPaymentOperation, PutPaymentRequestFunction } from "./putPayment";
import { putRateOperation, PutRateRequestFunction } from "./putRate";
import {
  putSubscriptionOperation,
  PutSubscriptionRequestFunction,
} from "./putSubscription";
import { putTagOperation, PutTagRequestFunction } from "./putTag";
import {
  putTrainingOperation,
  PutTrainingRequestFunction,
} from "./putTraining";
import {
  putTransactionOperation,
  PutTransactionRequestFunction,
} from "./putTransaction";
import {
  quoteCreditOperation,
  QuoteCreditRequestFunction,
} from "./quoteCredit";
import { quoteJobOperation, QuoteJobRequestFunction } from "./quoteJob";
import { quoteLeadOperation, QuoteLeadRequestFunction } from "./quoteLead";
import { reapplyJobOperation, ReapplyJobRequestFunction } from "./reapplyJob";
import { referLeadOperation, ReferLeadRequestFunction } from "./referLead";
import { resendJobOperation, ResendJobRequestFunction } from "./resendJob";
import { runnerOperation, RunnerRequestFunction } from "./runner";
import { sendJobOperation, SendJobRequestFunction } from "./sendJob";
import {
  sendLeadJobOperation,
  SendLeadJobRequestFunction,
} from "./sendLeadJob";
import { signCreditOperation, SignCreditRequestFunction } from "./signCredit";
import {
  signJobSatNoteOperation,
  SignJobSatNoteRequestFunction,
} from "./signJobSatNote";
import {
  submitIntroductionStateOperation,
  SubmitIntroductionStateRequestFunction,
} from "./submitIntroductionState";
import { tradeLeadOperation, TradeLeadRequestFunction } from "./tradeLead";
import {
  tradeQuoteApprovalLeadOperation,
  TradeQuoteApprovalLeadRequestFunction,
} from "./tradeQuoteApprovalLead";
import {
  unarchiveJobOperation,
  UnarchiveJobRequestFunction,
} from "./unarchiveJob";
import {
  viewJobSatNoteOperation,
  ViewJobSatNoteRequestFunction,
} from "./viewJobSatNote";

export const operations: Operations = {
  me: meOperation,
  postMe: postMeOperation,
  putMe: putMeOperation,
  infoHealth: infoHealthOperation,
  infoGhost: infoGhostOperation,
  infoQuery: infoQueryOperation,
  infoTradeSummary: infoTradeSummaryOperation,
  infoCompany: infoCompanyOperation,
  infoOnboarding: infoOnboardingOperation,
  infoDirector: infoDirectorOperation,
  infoCustomer: infoCustomerOperation,
  infoCampaign: infoCampaignOperation,
  infoExampleJob: infoExampleJobOperation,
  infoCredit: infoCreditOperation,
  infoAuth: infoAuthOperation,
  infoVerify: infoVerifyOperation,
  infoPassword: infoPasswordOperation,
  infoSession: infoSessionOperation,
  infoClaimAccount: infoClaimAccountOperation,
  infoRate: infoRateOperation,
  infoWorkType: infoWorkTypeOperation,
  infoLegacyRedirect: infoLegacyRedirectOperation,
  infoCheckoutRedirect: infoCheckoutRedirectOperation,
  infoIP: infoIPOperation,
  infoValidateEmail: infoValidateEmailOperation,
  infoGetCache: infoGetCacheOperation,
  infoPutCache: infoPutCacheOperation,
  infoDeleteCache: infoDeleteCacheOperation,
  getInfoEntity: getInfoEntityOperation,
  infoSearch: infoSearchOperation,
  infoPartnerBranding: infoPartnerBrandingOperation,
  infoEnterprise: infoEnterpriseOperation,
  infoEnterpriseRole: infoEnterpriseRoleOperation,
  infoRelation: infoRelationOperation,
  infoLead: infoLeadOperation,
  infoStats: infoStatsOperation,
  putInfoStats: putInfoStatsOperation,
  infoIntroductionStats: infoIntroductionStatsOperation,
  putInfoTag: putInfoTagOperation,
  getInfoEnquiry: getInfoEnquiryOperation,
  getPartners: getPartnersOperation,
  postPartner: postPartnerOperation,
  getPartner: getPartnerOperation,
  putPartner: putPartnerOperation,
  deletePartner: deletePartnerOperation,
  postPartnerReferrals: postPartnerReferralsOperation,
  getOnboardings: getOnboardingsOperation,
  postOnboarding: postOnboardingOperation,
  getOnboarding: getOnboardingOperation,
  putOnboarding: putOnboardingOperation,
  deleteOnboarding: deleteOnboardingOperation,
  postOnboardingDecision: postOnboardingDecisionOperation,
  getEnterprises: getEnterprisesOperation,
  postEnterprise: postEnterpriseOperation,
  getEnterprise: getEnterpriseOperation,
  putEnterprise: putEnterpriseOperation,
  deleteEnterprise: deleteEnterpriseOperation,
  getEnterpriseBranches: getEnterpriseBranchesOperation,
  postEnterpriseBranches: postEnterpriseBranchesOperation,
  exportEnterpriseDailyReport: exportEnterpriseDailyReportOperation,
  getIntroductions: getIntroductionsOperation,
  postIntroduction: postIntroductionOperation,
  getIntroduction: getIntroductionOperation,
  putIntroduction: putIntroductionOperation,
  deleteIntroduction: deleteIntroductionOperation,
  postIntroductionConsumerSignature: postIntroductionConsumerSignatureOperation,
  postIntroductionConsumerDetails: postIntroductionConsumerDetailsOperation,
  postIntroductionConsumerBudgets: postIntroductionConsumerBudgetsOperation,
  postIntroductionConsumerApply: postIntroductionConsumerApplyOperation,
  postIntroductionJobDetails: postIntroductionJobDetailsOperation,
  postIntroductionAmendJobDetails: postIntroductionAmendJobDetailsOperation,
  postIntroductionTrader: postIntroductionTraderOperation,
  postIntroductionTraderSignature: postIntroductionTraderSignatureOperation,
  postIntroductionTraderApproveAmended:
    postIntroductionTraderApproveAmendedOperation,
  postIntroductionTraderDetails: postIntroductionTraderDetailsOperation,
  postIntroductionRejectJob: postIntroductionRejectJobOperation,
  submitIntroductionState: submitIntroductionStateOperation,
  postIntroductionConvertJob: postIntroductionConvertJobOperation,
  postIntroductionNotification: postIntroductionNotificationOperation,
  actionIntroduction: actionIntroductionOperation,
  getCompanies: getCompaniesOperation,
  postCompany: postCompanyOperation,
  getCompany: getCompanyOperation,
  putCompany: putCompanyOperation,
  deleteCompany: deleteCompanyOperation,
  postCompanyBilling: postCompanyBillingOperation,
  postCompanyBillingSuccess: postCompanyBillingSuccessOperation,
  getCompanyDirectorVerification: getCompanyDirectorVerificationOperation,
  postCompanyDirectorVerification: postCompanyDirectorVerificationOperation,
  directorCompany: directorCompanyOperation,
  getCompanyReferrals: getCompanyReferralsOperation,
  postCompanyReferrals: postCompanyReferralsOperation,
  approveCompany: approveCompanyOperation,
  declineCompany: declineCompanyOperation,
  exportFcaApproved: exportFcaApprovedOperation,
  importFcaApproved: importFcaApprovedOperation,
  getJobs: getJobsOperation,
  postJob: postJobOperation,
  getJob: getJobOperation,
  putJob: putJobOperation,
  deleteJob: deleteJobOperation,
  sendJob: sendJobOperation,
  resendJob: resendJobOperation,
  checkJob: checkJobOperation,
  completeJob: completeJobOperation,
  archiveJob: archiveJobOperation,
  unarchiveJob: unarchiveJobOperation,
  quoteJob: quoteJobOperation,
  applyJob: applyJobOperation,
  reapplyJob: reapplyJobOperation,
  payJob: payJobOperation,
  viewJobSatNote: viewJobSatNoteOperation,
  signJobSatNote: signJobSatNoteOperation,
  approveJobSatNote: approveJobSatNoteOperation,
  lenderReviewJobSatNote: lenderReviewJobSatNoteOperation,
  delayJobSatNote: delayJobSatNoteOperation,
  payoutJob: payoutJobOperation,
  payoutsJob: payoutsJobOperation,
  overrideJob: overrideJobOperation,
  jobCheckoutLink: jobCheckoutLinkOperation,
  jobCompanyInfo: jobCompanyInfoOperation,
  exportJobPayouts: exportJobPayoutsOperation,
  getPayments: getPaymentsOperation,
  postPayment: postPaymentOperation,
  getPayment: getPaymentOperation,
  putPayment: putPaymentOperation,
  deletePayment: deletePaymentOperation,
  markPayment: markPaymentOperation,
  getCredits: getCreditsOperation,
  postCredit: postCreditOperation,
  getCredit: getCreditOperation,
  putCredit: putCreditOperation,
  deleteCredit: deleteCreditOperation,
  quoteCredit: quoteCreditOperation,
  applyCredit: applyCreditOperation,
  checkCredit: checkCreditOperation,
  signCredit: signCreditOperation,
  migrateCredit: migrateCreditOperation,
  consentMigrateCredit: consentMigrateCreditOperation,
  getDocuments: getDocumentsOperation,
  postDocument: postDocumentOperation,
  getDocument: getDocumentOperation,
  putDocument: putDocumentOperation,
  deleteDocument: deleteDocumentOperation,
  getLeads: getLeadsOperation,
  postLead: postLeadOperation,
  getLead: getLeadOperation,
  putLead: putLeadOperation,
  deleteLead: deleteLeadOperation,
  applyInviteLead: applyInviteLeadOperation,
  budgetLead: budgetLeadOperation,
  quoteLead: quoteLeadOperation,
  sendLeadJob: sendLeadJobOperation,
  tradeLead: tradeLeadOperation,
  tradeQuoteApprovalLead: tradeQuoteApprovalLeadOperation,
  matchTradesLead: matchTradesLeadOperation,
  connectTradesLead: connectTradesLeadOperation,
  acceptedJobSummaryLead: acceptedJobSummaryLeadOperation,
  referLead: referLeadOperation,
  getSubscriptions: getSubscriptionsOperation,
  postSubscription: postSubscriptionOperation,
  getSubscription: getSubscriptionOperation,
  putSubscription: putSubscriptionOperation,
  deleteSubscription: deleteSubscriptionOperation,
  pendingSubscription: pendingSubscriptionOperation,
  getTrainings: getTrainingsOperation,
  postTraining: postTrainingOperation,
  getTraining: getTrainingOperation,
  putTraining: putTrainingOperation,
  deleteTraining: deleteTrainingOperation,
  getRates: getRatesOperation,
  postRate: postRateOperation,
  getRate: getRateOperation,
  putRate: putRateOperation,
  deleteRate: deleteRateOperation,
  getMonitors: getMonitorsOperation,
  postMonitor: postMonitorOperation,
  getMonitor: getMonitorOperation,
  putMonitor: putMonitorOperation,
  deleteMonitor: deleteMonitorOperation,
  postMonitorFlag: postMonitorFlagOperation,
  getTransactions: getTransactionsOperation,
  postTransaction: postTransactionOperation,
  getTransaction: getTransactionOperation,
  putTransaction: putTransactionOperation,
  deleteTransaction: deleteTransactionOperation,
  getAudits: getAuditsOperation,
  postAudit: postAuditOperation,
  getAudit: getAuditOperation,
  getEnrolments: getEnrolmentsOperation,
  getEnrolment: getEnrolmentOperation,
  putEnrolment: putEnrolmentOperation,
  getEnquiries: getEnquiriesOperation,
  postEnquiry: postEnquiryOperation,
  getEnquiry: getEnquiryOperation,
  putEnquiry: putEnquiryOperation,
  deleteEnquiry: deleteEnquiryOperation,
  postEnquiryConsumer: postEnquiryConsumerOperation,
  postEnquiryConsumerSignature: postEnquiryConsumerSignatureOperation,
  postEnquiryConsumerPreferences: postEnquiryConsumerPreferencesOperation,
  postEnquiryQuote: postEnquiryQuoteOperation,
  postEnquiryJobInfo: postEnquiryJobInfoOperation,
  postEnquiryInterestInCredit: postEnquiryInterestInCreditOperation,
  postEnquiryBudget: postEnquiryBudgetOperation,
  postEnquirySubmit: postEnquirySubmitOperation,
  postEnquiryState: postEnquiryStateOperation,
  postEnquiryConvertJob: postEnquiryConvertJobOperation,
  postEnquiryArchive: postEnquiryArchiveOperation,
  postEnquiryUnarchive: postEnquiryUnarchiveOperation,
  getTags: getTagsOperation,
  postTag: postTagOperation,
  getTag: getTagOperation,
  putTag: putTagOperation,
  deleteTag: deleteTagOperation,
  providerCheckWebhook: providerCheckWebhookOperation,
  providerWebhook: providerWebhookOperation,
  actionAdhoc: actionAdhocOperation,
  postEvent: postEventOperation,
  runner: runnerOperation,
} as const;

export interface OperationRequestFunctionMap {
  me: MeRequestFunction;
  postMe: PostMeRequestFunction;
  putMe: PutMeRequestFunction;
  infoHealth: InfoHealthRequestFunction;
  infoGhost: InfoGhostRequestFunction;
  infoQuery: InfoQueryRequestFunction;
  infoTradeSummary: InfoTradeSummaryRequestFunction;
  infoCompany: InfoCompanyRequestFunction;
  infoOnboarding: InfoOnboardingRequestFunction;
  infoDirector: InfoDirectorRequestFunction;
  infoCustomer: InfoCustomerRequestFunction;
  infoCampaign: InfoCampaignRequestFunction;
  infoExampleJob: InfoExampleJobRequestFunction;
  infoCredit: InfoCreditRequestFunction;
  infoAuth: InfoAuthRequestFunction;
  infoVerify: InfoVerifyRequestFunction;
  infoPassword: InfoPasswordRequestFunction;
  infoSession: InfoSessionRequestFunction;
  infoClaimAccount: InfoClaimAccountRequestFunction;
  infoRate: InfoRateRequestFunction;
  infoWorkType: InfoWorkTypeRequestFunction;
  infoLegacyRedirect: InfoLegacyRedirectRequestFunction;
  infoCheckoutRedirect: InfoCheckoutRedirectRequestFunction;
  infoIP: InfoIPRequestFunction;
  infoValidateEmail: InfoValidateEmailRequestFunction;
  infoGetCache: InfoGetCacheRequestFunction;
  infoPutCache: InfoPutCacheRequestFunction;
  infoDeleteCache: InfoDeleteCacheRequestFunction;
  getInfoEntity: GetInfoEntityRequestFunction;
  infoSearch: InfoSearchRequestFunction;
  infoPartnerBranding: InfoPartnerBrandingRequestFunction;
  infoEnterprise: InfoEnterpriseRequestFunction;
  infoEnterpriseRole: InfoEnterpriseRoleRequestFunction;
  infoRelation: InfoRelationRequestFunction;
  infoLead: InfoLeadRequestFunction;
  infoStats: InfoStatsRequestFunction;
  putInfoStats: PutInfoStatsRequestFunction;
  infoIntroductionStats: InfoIntroductionStatsRequestFunction;
  putInfoTag: PutInfoTagRequestFunction;
  getInfoEnquiry: GetInfoEnquiryRequestFunction;
  getPartners: GetPartnersRequestFunction;
  postPartner: PostPartnerRequestFunction;
  getPartner: GetPartnerRequestFunction;
  putPartner: PutPartnerRequestFunction;
  deletePartner: DeletePartnerRequestFunction;
  postPartnerReferrals: PostPartnerReferralsRequestFunction;
  getOnboardings: GetOnboardingsRequestFunction;
  postOnboarding: PostOnboardingRequestFunction;
  getOnboarding: GetOnboardingRequestFunction;
  putOnboarding: PutOnboardingRequestFunction;
  deleteOnboarding: DeleteOnboardingRequestFunction;
  postOnboardingDecision: PostOnboardingDecisionRequestFunction;
  getEnterprises: GetEnterprisesRequestFunction;
  postEnterprise: PostEnterpriseRequestFunction;
  getEnterprise: GetEnterpriseRequestFunction;
  putEnterprise: PutEnterpriseRequestFunction;
  deleteEnterprise: DeleteEnterpriseRequestFunction;
  getEnterpriseBranches: GetEnterpriseBranchesRequestFunction;
  postEnterpriseBranches: PostEnterpriseBranchesRequestFunction;
  exportEnterpriseDailyReport: ExportEnterpriseDailyReportRequestFunction;
  getIntroductions: GetIntroductionsRequestFunction;
  postIntroduction: PostIntroductionRequestFunction;
  getIntroduction: GetIntroductionRequestFunction;
  putIntroduction: PutIntroductionRequestFunction;
  deleteIntroduction: DeleteIntroductionRequestFunction;
  postIntroductionConsumerSignature: PostIntroductionConsumerSignatureRequestFunction;
  postIntroductionConsumerDetails: PostIntroductionConsumerDetailsRequestFunction;
  postIntroductionConsumerBudgets: PostIntroductionConsumerBudgetsRequestFunction;
  postIntroductionConsumerApply: PostIntroductionConsumerApplyRequestFunction;
  postIntroductionJobDetails: PostIntroductionJobDetailsRequestFunction;
  postIntroductionAmendJobDetails: PostIntroductionAmendJobDetailsRequestFunction;
  postIntroductionTrader: PostIntroductionTraderRequestFunction;
  postIntroductionTraderSignature: PostIntroductionTraderSignatureRequestFunction;
  postIntroductionTraderApproveAmended: PostIntroductionTraderApproveAmendedRequestFunction;
  postIntroductionTraderDetails: PostIntroductionTraderDetailsRequestFunction;
  postIntroductionRejectJob: PostIntroductionRejectJobRequestFunction;
  submitIntroductionState: SubmitIntroductionStateRequestFunction;
  postIntroductionConvertJob: PostIntroductionConvertJobRequestFunction;
  postIntroductionNotification: PostIntroductionNotificationRequestFunction;
  actionIntroduction: ActionIntroductionRequestFunction;
  getCompanies: GetCompaniesRequestFunction;
  postCompany: PostCompanyRequestFunction;
  getCompany: GetCompanyRequestFunction;
  putCompany: PutCompanyRequestFunction;
  deleteCompany: DeleteCompanyRequestFunction;
  postCompanyBilling: PostCompanyBillingRequestFunction;
  postCompanyBillingSuccess: PostCompanyBillingSuccessRequestFunction;
  getCompanyDirectorVerification: GetCompanyDirectorVerificationRequestFunction;
  postCompanyDirectorVerification: PostCompanyDirectorVerificationRequestFunction;
  directorCompany: DirectorCompanyRequestFunction;
  getCompanyReferrals: GetCompanyReferralsRequestFunction;
  postCompanyReferrals: PostCompanyReferralsRequestFunction;
  approveCompany: ApproveCompanyRequestFunction;
  declineCompany: DeclineCompanyRequestFunction;
  exportFcaApproved: ExportFcaApprovedRequestFunction;
  importFcaApproved: ImportFcaApprovedRequestFunction;
  getJobs: GetJobsRequestFunction;
  postJob: PostJobRequestFunction;
  getJob: GetJobRequestFunction;
  putJob: PutJobRequestFunction;
  deleteJob: DeleteJobRequestFunction;
  sendJob: SendJobRequestFunction;
  resendJob: ResendJobRequestFunction;
  checkJob: CheckJobRequestFunction;
  completeJob: CompleteJobRequestFunction;
  archiveJob: ArchiveJobRequestFunction;
  unarchiveJob: UnarchiveJobRequestFunction;
  quoteJob: QuoteJobRequestFunction;
  applyJob: ApplyJobRequestFunction;
  reapplyJob: ReapplyJobRequestFunction;
  payJob: PayJobRequestFunction;
  viewJobSatNote: ViewJobSatNoteRequestFunction;
  signJobSatNote: SignJobSatNoteRequestFunction;
  approveJobSatNote: ApproveJobSatNoteRequestFunction;
  lenderReviewJobSatNote: LenderReviewJobSatNoteRequestFunction;
  delayJobSatNote: DelayJobSatNoteRequestFunction;
  payoutJob: PayoutJobRequestFunction;
  payoutsJob: PayoutsJobRequestFunction;
  overrideJob: OverrideJobRequestFunction;
  jobCheckoutLink: JobCheckoutLinkRequestFunction;
  jobCompanyInfo: JobCompanyInfoRequestFunction;
  exportJobPayouts: ExportJobPayoutsRequestFunction;
  getPayments: GetPaymentsRequestFunction;
  postPayment: PostPaymentRequestFunction;
  getPayment: GetPaymentRequestFunction;
  putPayment: PutPaymentRequestFunction;
  deletePayment: DeletePaymentRequestFunction;
  markPayment: MarkPaymentRequestFunction;
  getCredits: GetCreditsRequestFunction;
  postCredit: PostCreditRequestFunction;
  getCredit: GetCreditRequestFunction;
  putCredit: PutCreditRequestFunction;
  deleteCredit: DeleteCreditRequestFunction;
  quoteCredit: QuoteCreditRequestFunction;
  applyCredit: ApplyCreditRequestFunction;
  checkCredit: CheckCreditRequestFunction;
  signCredit: SignCreditRequestFunction;
  migrateCredit: MigrateCreditRequestFunction;
  consentMigrateCredit: ConsentMigrateCreditRequestFunction;
  getDocuments: GetDocumentsRequestFunction;
  postDocument: PostDocumentRequestFunction;
  getDocument: GetDocumentRequestFunction;
  putDocument: PutDocumentRequestFunction;
  deleteDocument: DeleteDocumentRequestFunction;
  getLeads: GetLeadsRequestFunction;
  postLead: PostLeadRequestFunction;
  getLead: GetLeadRequestFunction;
  putLead: PutLeadRequestFunction;
  deleteLead: DeleteLeadRequestFunction;
  applyInviteLead: ApplyInviteLeadRequestFunction;
  budgetLead: BudgetLeadRequestFunction;
  quoteLead: QuoteLeadRequestFunction;
  sendLeadJob: SendLeadJobRequestFunction;
  tradeLead: TradeLeadRequestFunction;
  tradeQuoteApprovalLead: TradeQuoteApprovalLeadRequestFunction;
  matchTradesLead: MatchTradesLeadRequestFunction;
  connectTradesLead: ConnectTradesLeadRequestFunction;
  acceptedJobSummaryLead: AcceptedJobSummaryLeadRequestFunction;
  referLead: ReferLeadRequestFunction;
  getSubscriptions: GetSubscriptionsRequestFunction;
  postSubscription: PostSubscriptionRequestFunction;
  getSubscription: GetSubscriptionRequestFunction;
  putSubscription: PutSubscriptionRequestFunction;
  deleteSubscription: DeleteSubscriptionRequestFunction;
  pendingSubscription: PendingSubscriptionRequestFunction;
  getTrainings: GetTrainingsRequestFunction;
  postTraining: PostTrainingRequestFunction;
  getTraining: GetTrainingRequestFunction;
  putTraining: PutTrainingRequestFunction;
  deleteTraining: DeleteTrainingRequestFunction;
  getRates: GetRatesRequestFunction;
  postRate: PostRateRequestFunction;
  getRate: GetRateRequestFunction;
  putRate: PutRateRequestFunction;
  deleteRate: DeleteRateRequestFunction;
  getMonitors: GetMonitorsRequestFunction;
  postMonitor: PostMonitorRequestFunction;
  getMonitor: GetMonitorRequestFunction;
  putMonitor: PutMonitorRequestFunction;
  deleteMonitor: DeleteMonitorRequestFunction;
  postMonitorFlag: PostMonitorFlagRequestFunction;
  getTransactions: GetTransactionsRequestFunction;
  postTransaction: PostTransactionRequestFunction;
  getTransaction: GetTransactionRequestFunction;
  putTransaction: PutTransactionRequestFunction;
  deleteTransaction: DeleteTransactionRequestFunction;
  getAudits: GetAuditsRequestFunction;
  postAudit: PostAuditRequestFunction;
  getAudit: GetAuditRequestFunction;
  getEnrolments: GetEnrolmentsRequestFunction;
  getEnrolment: GetEnrolmentRequestFunction;
  putEnrolment: PutEnrolmentRequestFunction;
  getEnquiries: GetEnquiriesRequestFunction;
  postEnquiry: PostEnquiryRequestFunction;
  getEnquiry: GetEnquiryRequestFunction;
  putEnquiry: PutEnquiryRequestFunction;
  deleteEnquiry: DeleteEnquiryRequestFunction;
  postEnquiryConsumer: PostEnquiryConsumerRequestFunction;
  postEnquiryConsumerSignature: PostEnquiryConsumerSignatureRequestFunction;
  postEnquiryConsumerPreferences: PostEnquiryConsumerPreferencesRequestFunction;
  postEnquiryQuote: PostEnquiryQuoteRequestFunction;
  postEnquiryJobInfo: PostEnquiryJobInfoRequestFunction;
  postEnquiryInterestInCredit: PostEnquiryInterestInCreditRequestFunction;
  postEnquiryBudget: PostEnquiryBudgetRequestFunction;
  postEnquirySubmit: PostEnquirySubmitRequestFunction;
  postEnquiryState: PostEnquiryStateRequestFunction;
  postEnquiryConvertJob: PostEnquiryConvertJobRequestFunction;
  postEnquiryArchive: PostEnquiryArchiveRequestFunction;
  postEnquiryUnarchive: PostEnquiryUnarchiveRequestFunction;
  getTags: GetTagsRequestFunction;
  postTag: PostTagRequestFunction;
  getTag: GetTagRequestFunction;
  putTag: PutTagRequestFunction;
  deleteTag: DeleteTagRequestFunction;
  providerCheckWebhook: ProviderCheckWebhookRequestFunction;
  providerWebhook: ProviderWebhookRequestFunction;
  actionAdhoc: ActionAdhocRequestFunction;
  postEvent: PostEventRequestFunction;
  runner: RunnerRequestFunction;
}

export const requestFunctionsBuilder = (
  requestAdapter: HttpRequestAdapter
): OperationRequestFunctionMap => ({
  me: requestFunctionBuilder(operations.me, requestAdapter),
  postMe: requestFunctionBuilder(operations.postMe, requestAdapter),
  putMe: requestFunctionBuilder(operations.putMe, requestAdapter),
  infoHealth: requestFunctionBuilder(operations.infoHealth, requestAdapter),
  infoGhost: requestFunctionBuilder(operations.infoGhost, requestAdapter),
  infoQuery: requestFunctionBuilder(operations.infoQuery, requestAdapter),
  infoTradeSummary: requestFunctionBuilder(
    operations.infoTradeSummary,
    requestAdapter
  ),
  infoCompany: requestFunctionBuilder(operations.infoCompany, requestAdapter),
  infoOnboarding: requestFunctionBuilder(
    operations.infoOnboarding,
    requestAdapter
  ),
  infoDirector: requestFunctionBuilder(operations.infoDirector, requestAdapter),
  infoCustomer: requestFunctionBuilder(operations.infoCustomer, requestAdapter),
  infoCampaign: requestFunctionBuilder(operations.infoCampaign, requestAdapter),
  infoExampleJob: requestFunctionBuilder(
    operations.infoExampleJob,
    requestAdapter
  ),
  infoCredit: requestFunctionBuilder(operations.infoCredit, requestAdapter),
  infoAuth: requestFunctionBuilder(operations.infoAuth, requestAdapter),
  infoVerify: requestFunctionBuilder(operations.infoVerify, requestAdapter),
  infoPassword: requestFunctionBuilder(operations.infoPassword, requestAdapter),
  infoSession: requestFunctionBuilder(operations.infoSession, requestAdapter),
  infoClaimAccount: requestFunctionBuilder(
    operations.infoClaimAccount,
    requestAdapter
  ),
  infoRate: requestFunctionBuilder(operations.infoRate, requestAdapter),
  infoWorkType: requestFunctionBuilder(operations.infoWorkType, requestAdapter),
  infoLegacyRedirect: requestFunctionBuilder(
    operations.infoLegacyRedirect,
    requestAdapter
  ),
  infoCheckoutRedirect: requestFunctionBuilder(
    operations.infoCheckoutRedirect,
    requestAdapter
  ),
  infoIP: requestFunctionBuilder(operations.infoIP, requestAdapter),
  infoValidateEmail: requestFunctionBuilder(
    operations.infoValidateEmail,
    requestAdapter
  ),
  infoGetCache: requestFunctionBuilder(operations.infoGetCache, requestAdapter),
  infoPutCache: requestFunctionBuilder(operations.infoPutCache, requestAdapter),
  infoDeleteCache: requestFunctionBuilder(
    operations.infoDeleteCache,
    requestAdapter
  ),
  getInfoEntity: requestFunctionBuilder(
    operations.getInfoEntity,
    requestAdapter
  ),
  infoSearch: requestFunctionBuilder(operations.infoSearch, requestAdapter),
  infoPartnerBranding: requestFunctionBuilder(
    operations.infoPartnerBranding,
    requestAdapter
  ),
  infoEnterprise: requestFunctionBuilder(
    operations.infoEnterprise,
    requestAdapter
  ),
  infoEnterpriseRole: requestFunctionBuilder(
    operations.infoEnterpriseRole,
    requestAdapter
  ),
  infoRelation: requestFunctionBuilder(operations.infoRelation, requestAdapter),
  infoLead: requestFunctionBuilder(operations.infoLead, requestAdapter),
  infoStats: requestFunctionBuilder(operations.infoStats, requestAdapter),
  putInfoStats: requestFunctionBuilder(operations.putInfoStats, requestAdapter),
  infoIntroductionStats: requestFunctionBuilder(
    operations.infoIntroductionStats,
    requestAdapter
  ),
  putInfoTag: requestFunctionBuilder(operations.putInfoTag, requestAdapter),
  getInfoEnquiry: requestFunctionBuilder(
    operations.getInfoEnquiry,
    requestAdapter
  ),
  getPartners: requestFunctionBuilder(operations.getPartners, requestAdapter),
  postPartner: requestFunctionBuilder(operations.postPartner, requestAdapter),
  getPartner: requestFunctionBuilder(operations.getPartner, requestAdapter),
  putPartner: requestFunctionBuilder(operations.putPartner, requestAdapter),
  deletePartner: requestFunctionBuilder(
    operations.deletePartner,
    requestAdapter
  ),
  postPartnerReferrals: requestFunctionBuilder(
    operations.postPartnerReferrals,
    requestAdapter
  ),
  getOnboardings: requestFunctionBuilder(
    operations.getOnboardings,
    requestAdapter
  ),
  postOnboarding: requestFunctionBuilder(
    operations.postOnboarding,
    requestAdapter
  ),
  getOnboarding: requestFunctionBuilder(
    operations.getOnboarding,
    requestAdapter
  ),
  putOnboarding: requestFunctionBuilder(
    operations.putOnboarding,
    requestAdapter
  ),
  deleteOnboarding: requestFunctionBuilder(
    operations.deleteOnboarding,
    requestAdapter
  ),
  postOnboardingDecision: requestFunctionBuilder(
    operations.postOnboardingDecision,
    requestAdapter
  ),
  getEnterprises: requestFunctionBuilder(
    operations.getEnterprises,
    requestAdapter
  ),
  postEnterprise: requestFunctionBuilder(
    operations.postEnterprise,
    requestAdapter
  ),
  getEnterprise: requestFunctionBuilder(
    operations.getEnterprise,
    requestAdapter
  ),
  putEnterprise: requestFunctionBuilder(
    operations.putEnterprise,
    requestAdapter
  ),
  deleteEnterprise: requestFunctionBuilder(
    operations.deleteEnterprise,
    requestAdapter
  ),
  getEnterpriseBranches: requestFunctionBuilder(
    operations.getEnterpriseBranches,
    requestAdapter
  ),
  postEnterpriseBranches: requestFunctionBuilder(
    operations.postEnterpriseBranches,
    requestAdapter
  ),
  exportEnterpriseDailyReport: requestFunctionBuilder(
    operations.exportEnterpriseDailyReport,
    requestAdapter
  ),
  getIntroductions: requestFunctionBuilder(
    operations.getIntroductions,
    requestAdapter
  ),
  postIntroduction: requestFunctionBuilder(
    operations.postIntroduction,
    requestAdapter
  ),
  getIntroduction: requestFunctionBuilder(
    operations.getIntroduction,
    requestAdapter
  ),
  putIntroduction: requestFunctionBuilder(
    operations.putIntroduction,
    requestAdapter
  ),
  deleteIntroduction: requestFunctionBuilder(
    operations.deleteIntroduction,
    requestAdapter
  ),
  postIntroductionConsumerSignature: requestFunctionBuilder(
    operations.postIntroductionConsumerSignature,
    requestAdapter
  ),
  postIntroductionConsumerDetails: requestFunctionBuilder(
    operations.postIntroductionConsumerDetails,
    requestAdapter
  ),
  postIntroductionConsumerBudgets: requestFunctionBuilder(
    operations.postIntroductionConsumerBudgets,
    requestAdapter
  ),
  postIntroductionConsumerApply: requestFunctionBuilder(
    operations.postIntroductionConsumerApply,
    requestAdapter
  ),
  postIntroductionJobDetails: requestFunctionBuilder(
    operations.postIntroductionJobDetails,
    requestAdapter
  ),
  postIntroductionAmendJobDetails: requestFunctionBuilder(
    operations.postIntroductionAmendJobDetails,
    requestAdapter
  ),
  postIntroductionTrader: requestFunctionBuilder(
    operations.postIntroductionTrader,
    requestAdapter
  ),
  postIntroductionTraderSignature: requestFunctionBuilder(
    operations.postIntroductionTraderSignature,
    requestAdapter
  ),
  postIntroductionTraderApproveAmended: requestFunctionBuilder(
    operations.postIntroductionTraderApproveAmended,
    requestAdapter
  ),
  postIntroductionTraderDetails: requestFunctionBuilder(
    operations.postIntroductionTraderDetails,
    requestAdapter
  ),
  postIntroductionRejectJob: requestFunctionBuilder(
    operations.postIntroductionRejectJob,
    requestAdapter
  ),
  submitIntroductionState: requestFunctionBuilder(
    operations.submitIntroductionState,
    requestAdapter
  ),
  postIntroductionConvertJob: requestFunctionBuilder(
    operations.postIntroductionConvertJob,
    requestAdapter
  ),
  postIntroductionNotification: requestFunctionBuilder(
    operations.postIntroductionNotification,
    requestAdapter
  ),
  actionIntroduction: requestFunctionBuilder(
    operations.actionIntroduction,
    requestAdapter
  ),
  getCompanies: requestFunctionBuilder(operations.getCompanies, requestAdapter),
  postCompany: requestFunctionBuilder(operations.postCompany, requestAdapter),
  getCompany: requestFunctionBuilder(operations.getCompany, requestAdapter),
  putCompany: requestFunctionBuilder(operations.putCompany, requestAdapter),
  deleteCompany: requestFunctionBuilder(
    operations.deleteCompany,
    requestAdapter
  ),
  postCompanyBilling: requestFunctionBuilder(
    operations.postCompanyBilling,
    requestAdapter
  ),
  postCompanyBillingSuccess: requestFunctionBuilder(
    operations.postCompanyBillingSuccess,
    requestAdapter
  ),
  getCompanyDirectorVerification: requestFunctionBuilder(
    operations.getCompanyDirectorVerification,
    requestAdapter
  ),
  postCompanyDirectorVerification: requestFunctionBuilder(
    operations.postCompanyDirectorVerification,
    requestAdapter
  ),
  directorCompany: requestFunctionBuilder(
    operations.directorCompany,
    requestAdapter
  ),
  getCompanyReferrals: requestFunctionBuilder(
    operations.getCompanyReferrals,
    requestAdapter
  ),
  postCompanyReferrals: requestFunctionBuilder(
    operations.postCompanyReferrals,
    requestAdapter
  ),
  approveCompany: requestFunctionBuilder(
    operations.approveCompany,
    requestAdapter
  ),
  declineCompany: requestFunctionBuilder(
    operations.declineCompany,
    requestAdapter
  ),
  exportFcaApproved: requestFunctionBuilder(
    operations.exportFcaApproved,
    requestAdapter
  ),
  importFcaApproved: requestFunctionBuilder(
    operations.importFcaApproved,
    requestAdapter
  ),
  getJobs: requestFunctionBuilder(operations.getJobs, requestAdapter),
  postJob: requestFunctionBuilder(operations.postJob, requestAdapter),
  getJob: requestFunctionBuilder(operations.getJob, requestAdapter),
  putJob: requestFunctionBuilder(operations.putJob, requestAdapter),
  deleteJob: requestFunctionBuilder(operations.deleteJob, requestAdapter),
  sendJob: requestFunctionBuilder(operations.sendJob, requestAdapter),
  resendJob: requestFunctionBuilder(operations.resendJob, requestAdapter),
  checkJob: requestFunctionBuilder(operations.checkJob, requestAdapter),
  completeJob: requestFunctionBuilder(operations.completeJob, requestAdapter),
  archiveJob: requestFunctionBuilder(operations.archiveJob, requestAdapter),
  unarchiveJob: requestFunctionBuilder(operations.unarchiveJob, requestAdapter),
  quoteJob: requestFunctionBuilder(operations.quoteJob, requestAdapter),
  applyJob: requestFunctionBuilder(operations.applyJob, requestAdapter),
  reapplyJob: requestFunctionBuilder(operations.reapplyJob, requestAdapter),
  payJob: requestFunctionBuilder(operations.payJob, requestAdapter),
  viewJobSatNote: requestFunctionBuilder(
    operations.viewJobSatNote,
    requestAdapter
  ),
  signJobSatNote: requestFunctionBuilder(
    operations.signJobSatNote,
    requestAdapter
  ),
  approveJobSatNote: requestFunctionBuilder(
    operations.approveJobSatNote,
    requestAdapter
  ),
  lenderReviewJobSatNote: requestFunctionBuilder(
    operations.lenderReviewJobSatNote,
    requestAdapter
  ),
  delayJobSatNote: requestFunctionBuilder(
    operations.delayJobSatNote,
    requestAdapter
  ),
  payoutJob: requestFunctionBuilder(operations.payoutJob, requestAdapter),
  payoutsJob: requestFunctionBuilder(operations.payoutsJob, requestAdapter),
  overrideJob: requestFunctionBuilder(operations.overrideJob, requestAdapter),
  jobCheckoutLink: requestFunctionBuilder(
    operations.jobCheckoutLink,
    requestAdapter
  ),
  jobCompanyInfo: requestFunctionBuilder(
    operations.jobCompanyInfo,
    requestAdapter
  ),
  exportJobPayouts: requestFunctionBuilder(
    operations.exportJobPayouts,
    requestAdapter
  ),
  getPayments: requestFunctionBuilder(operations.getPayments, requestAdapter),
  postPayment: requestFunctionBuilder(operations.postPayment, requestAdapter),
  getPayment: requestFunctionBuilder(operations.getPayment, requestAdapter),
  putPayment: requestFunctionBuilder(operations.putPayment, requestAdapter),
  deletePayment: requestFunctionBuilder(
    operations.deletePayment,
    requestAdapter
  ),
  markPayment: requestFunctionBuilder(operations.markPayment, requestAdapter),
  getCredits: requestFunctionBuilder(operations.getCredits, requestAdapter),
  postCredit: requestFunctionBuilder(operations.postCredit, requestAdapter),
  getCredit: requestFunctionBuilder(operations.getCredit, requestAdapter),
  putCredit: requestFunctionBuilder(operations.putCredit, requestAdapter),
  deleteCredit: requestFunctionBuilder(operations.deleteCredit, requestAdapter),
  quoteCredit: requestFunctionBuilder(operations.quoteCredit, requestAdapter),
  applyCredit: requestFunctionBuilder(operations.applyCredit, requestAdapter),
  checkCredit: requestFunctionBuilder(operations.checkCredit, requestAdapter),
  signCredit: requestFunctionBuilder(operations.signCredit, requestAdapter),
  migrateCredit: requestFunctionBuilder(
    operations.migrateCredit,
    requestAdapter
  ),
  consentMigrateCredit: requestFunctionBuilder(
    operations.consentMigrateCredit,
    requestAdapter
  ),
  getDocuments: requestFunctionBuilder(operations.getDocuments, requestAdapter),
  postDocument: requestFunctionBuilder(operations.postDocument, requestAdapter),
  getDocument: requestFunctionBuilder(operations.getDocument, requestAdapter),
  putDocument: requestFunctionBuilder(operations.putDocument, requestAdapter),
  deleteDocument: requestFunctionBuilder(
    operations.deleteDocument,
    requestAdapter
  ),
  getLeads: requestFunctionBuilder(operations.getLeads, requestAdapter),
  postLead: requestFunctionBuilder(operations.postLead, requestAdapter),
  getLead: requestFunctionBuilder(operations.getLead, requestAdapter),
  putLead: requestFunctionBuilder(operations.putLead, requestAdapter),
  deleteLead: requestFunctionBuilder(operations.deleteLead, requestAdapter),
  applyInviteLead: requestFunctionBuilder(
    operations.applyInviteLead,
    requestAdapter
  ),
  budgetLead: requestFunctionBuilder(operations.budgetLead, requestAdapter),
  quoteLead: requestFunctionBuilder(operations.quoteLead, requestAdapter),
  sendLeadJob: requestFunctionBuilder(operations.sendLeadJob, requestAdapter),
  tradeLead: requestFunctionBuilder(operations.tradeLead, requestAdapter),
  tradeQuoteApprovalLead: requestFunctionBuilder(
    operations.tradeQuoteApprovalLead,
    requestAdapter
  ),
  matchTradesLead: requestFunctionBuilder(
    operations.matchTradesLead,
    requestAdapter
  ),
  connectTradesLead: requestFunctionBuilder(
    operations.connectTradesLead,
    requestAdapter
  ),
  acceptedJobSummaryLead: requestFunctionBuilder(
    operations.acceptedJobSummaryLead,
    requestAdapter
  ),
  referLead: requestFunctionBuilder(operations.referLead, requestAdapter),
  getSubscriptions: requestFunctionBuilder(
    operations.getSubscriptions,
    requestAdapter
  ),
  postSubscription: requestFunctionBuilder(
    operations.postSubscription,
    requestAdapter
  ),
  getSubscription: requestFunctionBuilder(
    operations.getSubscription,
    requestAdapter
  ),
  putSubscription: requestFunctionBuilder(
    operations.putSubscription,
    requestAdapter
  ),
  deleteSubscription: requestFunctionBuilder(
    operations.deleteSubscription,
    requestAdapter
  ),
  pendingSubscription: requestFunctionBuilder(
    operations.pendingSubscription,
    requestAdapter
  ),
  getTrainings: requestFunctionBuilder(operations.getTrainings, requestAdapter),
  postTraining: requestFunctionBuilder(operations.postTraining, requestAdapter),
  getTraining: requestFunctionBuilder(operations.getTraining, requestAdapter),
  putTraining: requestFunctionBuilder(operations.putTraining, requestAdapter),
  deleteTraining: requestFunctionBuilder(
    operations.deleteTraining,
    requestAdapter
  ),
  getRates: requestFunctionBuilder(operations.getRates, requestAdapter),
  postRate: requestFunctionBuilder(operations.postRate, requestAdapter),
  getRate: requestFunctionBuilder(operations.getRate, requestAdapter),
  putRate: requestFunctionBuilder(operations.putRate, requestAdapter),
  deleteRate: requestFunctionBuilder(operations.deleteRate, requestAdapter),
  getMonitors: requestFunctionBuilder(operations.getMonitors, requestAdapter),
  postMonitor: requestFunctionBuilder(operations.postMonitor, requestAdapter),
  getMonitor: requestFunctionBuilder(operations.getMonitor, requestAdapter),
  putMonitor: requestFunctionBuilder(operations.putMonitor, requestAdapter),
  deleteMonitor: requestFunctionBuilder(
    operations.deleteMonitor,
    requestAdapter
  ),
  postMonitorFlag: requestFunctionBuilder(
    operations.postMonitorFlag,
    requestAdapter
  ),
  getTransactions: requestFunctionBuilder(
    operations.getTransactions,
    requestAdapter
  ),
  postTransaction: requestFunctionBuilder(
    operations.postTransaction,
    requestAdapter
  ),
  getTransaction: requestFunctionBuilder(
    operations.getTransaction,
    requestAdapter
  ),
  putTransaction: requestFunctionBuilder(
    operations.putTransaction,
    requestAdapter
  ),
  deleteTransaction: requestFunctionBuilder(
    operations.deleteTransaction,
    requestAdapter
  ),
  getAudits: requestFunctionBuilder(operations.getAudits, requestAdapter),
  postAudit: requestFunctionBuilder(operations.postAudit, requestAdapter),
  getAudit: requestFunctionBuilder(operations.getAudit, requestAdapter),
  getEnrolments: requestFunctionBuilder(
    operations.getEnrolments,
    requestAdapter
  ),
  getEnrolment: requestFunctionBuilder(operations.getEnrolment, requestAdapter),
  putEnrolment: requestFunctionBuilder(operations.putEnrolment, requestAdapter),
  getEnquiries: requestFunctionBuilder(operations.getEnquiries, requestAdapter),
  postEnquiry: requestFunctionBuilder(operations.postEnquiry, requestAdapter),
  getEnquiry: requestFunctionBuilder(operations.getEnquiry, requestAdapter),
  putEnquiry: requestFunctionBuilder(operations.putEnquiry, requestAdapter),
  deleteEnquiry: requestFunctionBuilder(
    operations.deleteEnquiry,
    requestAdapter
  ),
  postEnquiryConsumer: requestFunctionBuilder(
    operations.postEnquiryConsumer,
    requestAdapter
  ),
  postEnquiryConsumerSignature: requestFunctionBuilder(
    operations.postEnquiryConsumerSignature,
    requestAdapter
  ),
  postEnquiryConsumerPreferences: requestFunctionBuilder(
    operations.postEnquiryConsumerPreferences,
    requestAdapter
  ),
  postEnquiryQuote: requestFunctionBuilder(
    operations.postEnquiryQuote,
    requestAdapter
  ),
  postEnquiryJobInfo: requestFunctionBuilder(
    operations.postEnquiryJobInfo,
    requestAdapter
  ),
  postEnquiryInterestInCredit: requestFunctionBuilder(
    operations.postEnquiryInterestInCredit,
    requestAdapter
  ),
  postEnquiryBudget: requestFunctionBuilder(
    operations.postEnquiryBudget,
    requestAdapter
  ),
  postEnquirySubmit: requestFunctionBuilder(
    operations.postEnquirySubmit,
    requestAdapter
  ),
  postEnquiryState: requestFunctionBuilder(
    operations.postEnquiryState,
    requestAdapter
  ),
  postEnquiryConvertJob: requestFunctionBuilder(
    operations.postEnquiryConvertJob,
    requestAdapter
  ),
  postEnquiryArchive: requestFunctionBuilder(
    operations.postEnquiryArchive,
    requestAdapter
  ),
  postEnquiryUnarchive: requestFunctionBuilder(
    operations.postEnquiryUnarchive,
    requestAdapter
  ),
  getTags: requestFunctionBuilder(operations.getTags, requestAdapter),
  postTag: requestFunctionBuilder(operations.postTag, requestAdapter),
  getTag: requestFunctionBuilder(operations.getTag, requestAdapter),
  putTag: requestFunctionBuilder(operations.putTag, requestAdapter),
  deleteTag: requestFunctionBuilder(operations.deleteTag, requestAdapter),
  providerCheckWebhook: requestFunctionBuilder(
    operations.providerCheckWebhook,
    requestAdapter
  ),
  providerWebhook: requestFunctionBuilder(
    operations.providerWebhook,
    requestAdapter
  ),
  actionAdhoc: requestFunctionBuilder(operations.actionAdhoc, requestAdapter),
  postEvent: requestFunctionBuilder(operations.postEvent, requestAdapter),
  runner: requestFunctionBuilder(operations.runner, requestAdapter),
});

export const authUserServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  me: requestFunctions.me,
  postMe: requestFunctions.postMe,
  putMe: requestFunctions.putMe,
});

export const infoHealthServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoHealth: requestFunctions.infoHealth,
});

export const infoGhostServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoGhost: requestFunctions.infoGhost,
});

export const infoQueryServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoQuery: requestFunctions.infoQuery,
});

export const tradeSummaryServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoTradeSummary: requestFunctions.infoTradeSummary,
});

export const infoCompanyServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoCompany: requestFunctions.infoCompany,
});

export const infoOnboardingServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoOnboarding: requestFunctions.infoOnboarding,
});

export const infoDirectorServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoDirector: requestFunctions.infoDirector,
});

export const infoCustomerServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoCustomer: requestFunctions.infoCustomer,
});

export const infoCampaignServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoCampaign: requestFunctions.infoCampaign,
});

export const jobServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoExampleJob: requestFunctions.infoExampleJob,
  getJobs: requestFunctions.getJobs,
  postJob: requestFunctions.postJob,
  getJob: requestFunctions.getJob,
  putJob: requestFunctions.putJob,
  deleteJob: requestFunctions.deleteJob,
  sendJob: requestFunctions.sendJob,
  resendJob: requestFunctions.resendJob,
  checkJob: requestFunctions.checkJob,
  completeJob: requestFunctions.completeJob,
  archiveJob: requestFunctions.archiveJob,
  unarchiveJob: requestFunctions.unarchiveJob,
  quoteJob: requestFunctions.quoteJob,
  applyJob: requestFunctions.applyJob,
  reapplyJob: requestFunctions.reapplyJob,
  payJob: requestFunctions.payJob,
  viewJobSatNote: requestFunctions.viewJobSatNote,
  signJobSatNote: requestFunctions.signJobSatNote,
  approveJobSatNote: requestFunctions.approveJobSatNote,
  lenderReviewJobSatNote: requestFunctions.lenderReviewJobSatNote,
  delayJobSatNote: requestFunctions.delayJobSatNote,
  payoutJob: requestFunctions.payoutJob,
  payoutsJob: requestFunctions.payoutsJob,
  overrideJob: requestFunctions.overrideJob,
  jobCheckoutLink: requestFunctions.jobCheckoutLink,
  jobCompanyInfo: requestFunctions.jobCompanyInfo,
  exportJobPayouts: requestFunctions.exportJobPayouts,
});

export const creditServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoCredit: requestFunctions.infoCredit,
  getCredits: requestFunctions.getCredits,
  postCredit: requestFunctions.postCredit,
  getCredit: requestFunctions.getCredit,
  putCredit: requestFunctions.putCredit,
  deleteCredit: requestFunctions.deleteCredit,
  quoteCredit: requestFunctions.quoteCredit,
  applyCredit: requestFunctions.applyCredit,
  checkCredit: requestFunctions.checkCredit,
  signCredit: requestFunctions.signCredit,
  migrateCredit: requestFunctions.migrateCredit,
  consentMigrateCredit: requestFunctions.consentMigrateCredit,
});

export const infoAuthServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoAuth: requestFunctions.infoAuth,
  infoVerify: requestFunctions.infoVerify,
  infoPassword: requestFunctions.infoPassword,
  infoSession: requestFunctions.infoSession,
  infoClaimAccount: requestFunctions.infoClaimAccount,
});

export const rateServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoRate: requestFunctions.infoRate,
  getRates: requestFunctions.getRates,
  postRate: requestFunctions.postRate,
  getRate: requestFunctions.getRate,
  putRate: requestFunctions.putRate,
  deleteRate: requestFunctions.deleteRate,
});

export const infoWorkTypeServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoWorkType: requestFunctions.infoWorkType,
});

export const infoRedirectServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoLegacyRedirect: requestFunctions.infoLegacyRedirect,
  infoCheckoutRedirect: requestFunctions.infoCheckoutRedirect,
});

export const infoIPServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoIP: requestFunctions.infoIP,
});

export const infoValidationServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoValidateEmail: requestFunctions.infoValidateEmail,
});

export const infoCacheServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoGetCache: requestFunctions.infoGetCache,
  infoPutCache: requestFunctions.infoPutCache,
  infoDeleteCache: requestFunctions.infoDeleteCache,
});

export const infoEntityServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getInfoEntity: requestFunctions.getInfoEntity,
});

export const infoSearchServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoSearch: requestFunctions.infoSearch,
});

export const infoPartnerServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoPartnerBranding: requestFunctions.infoPartnerBranding,
});

export const infoEnterpriseServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoEnterprise: requestFunctions.infoEnterprise,
});

export const infoEnterpriseRoleServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoEnterpriseRole: requestFunctions.infoEnterpriseRole,
});

export const infoRelationServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoRelation: requestFunctions.infoRelation,
});

export const infoLeadServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoLead: requestFunctions.infoLead,
});

export const infoStatsServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoStats: requestFunctions.infoStats,
  putInfoStats: requestFunctions.putInfoStats,
});

export const infoIntroductionStatsServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  infoIntroductionStats: requestFunctions.infoIntroductionStats,
});

export const infoTagServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  putInfoTag: requestFunctions.putInfoTag,
});

export const infoEnquiryServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getInfoEnquiry: requestFunctions.getInfoEnquiry,
});

export const partnerServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getPartners: requestFunctions.getPartners,
  postPartner: requestFunctions.postPartner,
  getPartner: requestFunctions.getPartner,
  putPartner: requestFunctions.putPartner,
  deletePartner: requestFunctions.deletePartner,
  postPartnerReferrals: requestFunctions.postPartnerReferrals,
});

export const onboardingServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getOnboardings: requestFunctions.getOnboardings,
  postOnboarding: requestFunctions.postOnboarding,
  getOnboarding: requestFunctions.getOnboarding,
  putOnboarding: requestFunctions.putOnboarding,
  deleteOnboarding: requestFunctions.deleteOnboarding,
  postOnboardingDecision: requestFunctions.postOnboardingDecision,
});

export const enterpriseServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getEnterprises: requestFunctions.getEnterprises,
  postEnterprise: requestFunctions.postEnterprise,
  getEnterprise: requestFunctions.getEnterprise,
  putEnterprise: requestFunctions.putEnterprise,
  deleteEnterprise: requestFunctions.deleteEnterprise,
  getEnterpriseBranches: requestFunctions.getEnterpriseBranches,
  postEnterpriseBranches: requestFunctions.postEnterpriseBranches,
  exportEnterpriseDailyReport: requestFunctions.exportEnterpriseDailyReport,
});

export const introductionServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getIntroductions: requestFunctions.getIntroductions,
  postIntroduction: requestFunctions.postIntroduction,
  getIntroduction: requestFunctions.getIntroduction,
  putIntroduction: requestFunctions.putIntroduction,
  deleteIntroduction: requestFunctions.deleteIntroduction,
  postIntroductionConsumerSignature:
    requestFunctions.postIntroductionConsumerSignature,
  postIntroductionConsumerDetails:
    requestFunctions.postIntroductionConsumerDetails,
  postIntroductionConsumerBudgets:
    requestFunctions.postIntroductionConsumerBudgets,
  postIntroductionConsumerApply: requestFunctions.postIntroductionConsumerApply,
  postIntroductionJobDetails: requestFunctions.postIntroductionJobDetails,
  postIntroductionAmendJobDetails:
    requestFunctions.postIntroductionAmendJobDetails,
  postIntroductionTrader: requestFunctions.postIntroductionTrader,
  postIntroductionTraderSignature:
    requestFunctions.postIntroductionTraderSignature,
  postIntroductionTraderApproveAmended:
    requestFunctions.postIntroductionTraderApproveAmended,
  postIntroductionTraderDetails: requestFunctions.postIntroductionTraderDetails,
  postIntroductionRejectJob: requestFunctions.postIntroductionRejectJob,
  submitIntroductionState: requestFunctions.submitIntroductionState,
  postIntroductionConvertJob: requestFunctions.postIntroductionConvertJob,
  postIntroductionNotification: requestFunctions.postIntroductionNotification,
  actionIntroduction: requestFunctions.actionIntroduction,
});

export const companyServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getCompanies: requestFunctions.getCompanies,
  postCompany: requestFunctions.postCompany,
  getCompany: requestFunctions.getCompany,
  putCompany: requestFunctions.putCompany,
  deleteCompany: requestFunctions.deleteCompany,
  postCompanyBilling: requestFunctions.postCompanyBilling,
  postCompanyBillingSuccess: requestFunctions.postCompanyBillingSuccess,
  getCompanyDirectorVerification:
    requestFunctions.getCompanyDirectorVerification,
  postCompanyDirectorVerification:
    requestFunctions.postCompanyDirectorVerification,
  directorCompany: requestFunctions.directorCompany,
  getCompanyReferrals: requestFunctions.getCompanyReferrals,
  postCompanyReferrals: requestFunctions.postCompanyReferrals,
  approveCompany: requestFunctions.approveCompany,
  declineCompany: requestFunctions.declineCompany,
  exportFcaApproved: requestFunctions.exportFcaApproved,
  importFcaApproved: requestFunctions.importFcaApproved,
});

export const paymentServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getPayments: requestFunctions.getPayments,
  postPayment: requestFunctions.postPayment,
  getPayment: requestFunctions.getPayment,
  putPayment: requestFunctions.putPayment,
  deletePayment: requestFunctions.deletePayment,
  markPayment: requestFunctions.markPayment,
});

export const documentServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getDocuments: requestFunctions.getDocuments,
  postDocument: requestFunctions.postDocument,
  getDocument: requestFunctions.getDocument,
  putDocument: requestFunctions.putDocument,
  deleteDocument: requestFunctions.deleteDocument,
});

export const leadServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getLeads: requestFunctions.getLeads,
  postLead: requestFunctions.postLead,
  getLead: requestFunctions.getLead,
  putLead: requestFunctions.putLead,
  deleteLead: requestFunctions.deleteLead,
  applyInviteLead: requestFunctions.applyInviteLead,
  budgetLead: requestFunctions.budgetLead,
  quoteLead: requestFunctions.quoteLead,
  sendLeadJob: requestFunctions.sendLeadJob,
  tradeLead: requestFunctions.tradeLead,
  tradeQuoteApprovalLead: requestFunctions.tradeQuoteApprovalLead,
  matchTradesLead: requestFunctions.matchTradesLead,
  connectTradesLead: requestFunctions.connectTradesLead,
  acceptedJobSummaryLead: requestFunctions.acceptedJobSummaryLead,
  referLead: requestFunctions.referLead,
});

export const subscriptionServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getSubscriptions: requestFunctions.getSubscriptions,
  postSubscription: requestFunctions.postSubscription,
  getSubscription: requestFunctions.getSubscription,
  putSubscription: requestFunctions.putSubscription,
  deleteSubscription: requestFunctions.deleteSubscription,
  pendingSubscription: requestFunctions.pendingSubscription,
});

export const trainingServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getTrainings: requestFunctions.getTrainings,
  postTraining: requestFunctions.postTraining,
  getTraining: requestFunctions.getTraining,
  putTraining: requestFunctions.putTraining,
  deleteTraining: requestFunctions.deleteTraining,
});

export const monitorServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getMonitors: requestFunctions.getMonitors,
  postMonitor: requestFunctions.postMonitor,
  getMonitor: requestFunctions.getMonitor,
  putMonitor: requestFunctions.putMonitor,
  deleteMonitor: requestFunctions.deleteMonitor,
  postMonitorFlag: requestFunctions.postMonitorFlag,
});

export const transactionServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getTransactions: requestFunctions.getTransactions,
  postTransaction: requestFunctions.postTransaction,
  getTransaction: requestFunctions.getTransaction,
  putTransaction: requestFunctions.putTransaction,
  deleteTransaction: requestFunctions.deleteTransaction,
});

export const auditServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getAudits: requestFunctions.getAudits,
  postAudit: requestFunctions.postAudit,
  getAudit: requestFunctions.getAudit,
});

export const enrolmentServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getEnrolments: requestFunctions.getEnrolments,
  getEnrolment: requestFunctions.getEnrolment,
  putEnrolment: requestFunctions.putEnrolment,
});

export const enquiryServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getEnquiries: requestFunctions.getEnquiries,
  postEnquiry: requestFunctions.postEnquiry,
  getEnquiry: requestFunctions.getEnquiry,
  putEnquiry: requestFunctions.putEnquiry,
  deleteEnquiry: requestFunctions.deleteEnquiry,
  postEnquiryConsumer: requestFunctions.postEnquiryConsumer,
  postEnquiryConsumerSignature: requestFunctions.postEnquiryConsumerSignature,
  postEnquiryConsumerPreferences:
    requestFunctions.postEnquiryConsumerPreferences,
  postEnquiryQuote: requestFunctions.postEnquiryQuote,
  postEnquiryJobInfo: requestFunctions.postEnquiryJobInfo,
  postEnquiryInterestInCredit: requestFunctions.postEnquiryInterestInCredit,
  postEnquiryBudget: requestFunctions.postEnquiryBudget,
  postEnquirySubmit: requestFunctions.postEnquirySubmit,
  postEnquiryState: requestFunctions.postEnquiryState,
  postEnquiryConvertJob: requestFunctions.postEnquiryConvertJob,
  postEnquiryArchive: requestFunctions.postEnquiryArchive,
  postEnquiryUnarchive: requestFunctions.postEnquiryUnarchive,
});

export const tagServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  getTags: requestFunctions.getTags,
  postTag: requestFunctions.postTag,
  getTag: requestFunctions.getTag,
  putTag: requestFunctions.putTag,
  deleteTag: requestFunctions.deleteTag,
});

export const webhookServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  providerCheckWebhook: requestFunctions.providerCheckWebhook,
  providerWebhook: requestFunctions.providerWebhook,
});

export const adhocServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  actionAdhoc: requestFunctions.actionAdhoc,
});

export const eventServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  postEvent: requestFunctions.postEvent,
});

export const taskServiceBuilder = (
  requestFunctions: OperationRequestFunctionMap
) => ({
  runner: requestFunctions.runner,
});

export interface Operations {
  me: typeof meOperation;
  postMe: typeof postMeOperation;
  putMe: typeof putMeOperation;
  infoHealth: typeof infoHealthOperation;
  infoGhost: typeof infoGhostOperation;
  infoQuery: typeof infoQueryOperation;
  infoTradeSummary: typeof infoTradeSummaryOperation;
  infoCompany: typeof infoCompanyOperation;
  infoOnboarding: typeof infoOnboardingOperation;
  infoDirector: typeof infoDirectorOperation;
  infoCustomer: typeof infoCustomerOperation;
  infoCampaign: typeof infoCampaignOperation;
  infoExampleJob: typeof infoExampleJobOperation;
  infoCredit: typeof infoCreditOperation;
  infoAuth: typeof infoAuthOperation;
  infoVerify: typeof infoVerifyOperation;
  infoPassword: typeof infoPasswordOperation;
  infoSession: typeof infoSessionOperation;
  infoClaimAccount: typeof infoClaimAccountOperation;
  infoRate: typeof infoRateOperation;
  infoWorkType: typeof infoWorkTypeOperation;
  infoLegacyRedirect: typeof infoLegacyRedirectOperation;
  infoCheckoutRedirect: typeof infoCheckoutRedirectOperation;
  infoIP: typeof infoIPOperation;
  infoValidateEmail: typeof infoValidateEmailOperation;
  infoGetCache: typeof infoGetCacheOperation;
  infoPutCache: typeof infoPutCacheOperation;
  infoDeleteCache: typeof infoDeleteCacheOperation;
  getInfoEntity: typeof getInfoEntityOperation;
  infoSearch: typeof infoSearchOperation;
  infoPartnerBranding: typeof infoPartnerBrandingOperation;
  infoEnterprise: typeof infoEnterpriseOperation;
  infoEnterpriseRole: typeof infoEnterpriseRoleOperation;
  infoRelation: typeof infoRelationOperation;
  infoLead: typeof infoLeadOperation;
  infoStats: typeof infoStatsOperation;
  putInfoStats: typeof putInfoStatsOperation;
  infoIntroductionStats: typeof infoIntroductionStatsOperation;
  putInfoTag: typeof putInfoTagOperation;
  getInfoEnquiry: typeof getInfoEnquiryOperation;
  getPartners: typeof getPartnersOperation;
  postPartner: typeof postPartnerOperation;
  getPartner: typeof getPartnerOperation;
  putPartner: typeof putPartnerOperation;
  deletePartner: typeof deletePartnerOperation;
  postPartnerReferrals: typeof postPartnerReferralsOperation;
  getOnboardings: typeof getOnboardingsOperation;
  postOnboarding: typeof postOnboardingOperation;
  getOnboarding: typeof getOnboardingOperation;
  putOnboarding: typeof putOnboardingOperation;
  deleteOnboarding: typeof deleteOnboardingOperation;
  postOnboardingDecision: typeof postOnboardingDecisionOperation;
  getEnterprises: typeof getEnterprisesOperation;
  postEnterprise: typeof postEnterpriseOperation;
  getEnterprise: typeof getEnterpriseOperation;
  putEnterprise: typeof putEnterpriseOperation;
  deleteEnterprise: typeof deleteEnterpriseOperation;
  getEnterpriseBranches: typeof getEnterpriseBranchesOperation;
  postEnterpriseBranches: typeof postEnterpriseBranchesOperation;
  exportEnterpriseDailyReport: typeof exportEnterpriseDailyReportOperation;
  getIntroductions: typeof getIntroductionsOperation;
  postIntroduction: typeof postIntroductionOperation;
  getIntroduction: typeof getIntroductionOperation;
  putIntroduction: typeof putIntroductionOperation;
  deleteIntroduction: typeof deleteIntroductionOperation;
  postIntroductionConsumerSignature: typeof postIntroductionConsumerSignatureOperation;
  postIntroductionConsumerDetails: typeof postIntroductionConsumerDetailsOperation;
  postIntroductionConsumerBudgets: typeof postIntroductionConsumerBudgetsOperation;
  postIntroductionConsumerApply: typeof postIntroductionConsumerApplyOperation;
  postIntroductionJobDetails: typeof postIntroductionJobDetailsOperation;
  postIntroductionAmendJobDetails: typeof postIntroductionAmendJobDetailsOperation;
  postIntroductionTrader: typeof postIntroductionTraderOperation;
  postIntroductionTraderSignature: typeof postIntroductionTraderSignatureOperation;
  postIntroductionTraderApproveAmended: typeof postIntroductionTraderApproveAmendedOperation;
  postIntroductionTraderDetails: typeof postIntroductionTraderDetailsOperation;
  postIntroductionRejectJob: typeof postIntroductionRejectJobOperation;
  submitIntroductionState: typeof submitIntroductionStateOperation;
  postIntroductionConvertJob: typeof postIntroductionConvertJobOperation;
  postIntroductionNotification: typeof postIntroductionNotificationOperation;
  actionIntroduction: typeof actionIntroductionOperation;
  getCompanies: typeof getCompaniesOperation;
  postCompany: typeof postCompanyOperation;
  getCompany: typeof getCompanyOperation;
  putCompany: typeof putCompanyOperation;
  deleteCompany: typeof deleteCompanyOperation;
  postCompanyBilling: typeof postCompanyBillingOperation;
  postCompanyBillingSuccess: typeof postCompanyBillingSuccessOperation;
  getCompanyDirectorVerification: typeof getCompanyDirectorVerificationOperation;
  postCompanyDirectorVerification: typeof postCompanyDirectorVerificationOperation;
  directorCompany: typeof directorCompanyOperation;
  getCompanyReferrals: typeof getCompanyReferralsOperation;
  postCompanyReferrals: typeof postCompanyReferralsOperation;
  approveCompany: typeof approveCompanyOperation;
  declineCompany: typeof declineCompanyOperation;
  exportFcaApproved: typeof exportFcaApprovedOperation;
  importFcaApproved: typeof importFcaApprovedOperation;
  getJobs: typeof getJobsOperation;
  postJob: typeof postJobOperation;
  getJob: typeof getJobOperation;
  putJob: typeof putJobOperation;
  deleteJob: typeof deleteJobOperation;
  sendJob: typeof sendJobOperation;
  resendJob: typeof resendJobOperation;
  checkJob: typeof checkJobOperation;
  completeJob: typeof completeJobOperation;
  archiveJob: typeof archiveJobOperation;
  unarchiveJob: typeof unarchiveJobOperation;
  quoteJob: typeof quoteJobOperation;
  applyJob: typeof applyJobOperation;
  reapplyJob: typeof reapplyJobOperation;
  payJob: typeof payJobOperation;
  viewJobSatNote: typeof viewJobSatNoteOperation;
  signJobSatNote: typeof signJobSatNoteOperation;
  approveJobSatNote: typeof approveJobSatNoteOperation;
  lenderReviewJobSatNote: typeof lenderReviewJobSatNoteOperation;
  delayJobSatNote: typeof delayJobSatNoteOperation;
  payoutJob: typeof payoutJobOperation;
  payoutsJob: typeof payoutsJobOperation;
  overrideJob: typeof overrideJobOperation;
  jobCheckoutLink: typeof jobCheckoutLinkOperation;
  jobCompanyInfo: typeof jobCompanyInfoOperation;
  exportJobPayouts: typeof exportJobPayoutsOperation;
  getPayments: typeof getPaymentsOperation;
  postPayment: typeof postPaymentOperation;
  getPayment: typeof getPaymentOperation;
  putPayment: typeof putPaymentOperation;
  deletePayment: typeof deletePaymentOperation;
  markPayment: typeof markPaymentOperation;
  getCredits: typeof getCreditsOperation;
  postCredit: typeof postCreditOperation;
  getCredit: typeof getCreditOperation;
  putCredit: typeof putCreditOperation;
  deleteCredit: typeof deleteCreditOperation;
  quoteCredit: typeof quoteCreditOperation;
  applyCredit: typeof applyCreditOperation;
  checkCredit: typeof checkCreditOperation;
  signCredit: typeof signCreditOperation;
  migrateCredit: typeof migrateCreditOperation;
  consentMigrateCredit: typeof consentMigrateCreditOperation;
  getDocuments: typeof getDocumentsOperation;
  postDocument: typeof postDocumentOperation;
  getDocument: typeof getDocumentOperation;
  putDocument: typeof putDocumentOperation;
  deleteDocument: typeof deleteDocumentOperation;
  getLeads: typeof getLeadsOperation;
  postLead: typeof postLeadOperation;
  getLead: typeof getLeadOperation;
  putLead: typeof putLeadOperation;
  deleteLead: typeof deleteLeadOperation;
  applyInviteLead: typeof applyInviteLeadOperation;
  budgetLead: typeof budgetLeadOperation;
  quoteLead: typeof quoteLeadOperation;
  sendLeadJob: typeof sendLeadJobOperation;
  tradeLead: typeof tradeLeadOperation;
  tradeQuoteApprovalLead: typeof tradeQuoteApprovalLeadOperation;
  matchTradesLead: typeof matchTradesLeadOperation;
  connectTradesLead: typeof connectTradesLeadOperation;
  acceptedJobSummaryLead: typeof acceptedJobSummaryLeadOperation;
  referLead: typeof referLeadOperation;
  getSubscriptions: typeof getSubscriptionsOperation;
  postSubscription: typeof postSubscriptionOperation;
  getSubscription: typeof getSubscriptionOperation;
  putSubscription: typeof putSubscriptionOperation;
  deleteSubscription: typeof deleteSubscriptionOperation;
  pendingSubscription: typeof pendingSubscriptionOperation;
  getTrainings: typeof getTrainingsOperation;
  postTraining: typeof postTrainingOperation;
  getTraining: typeof getTrainingOperation;
  putTraining: typeof putTrainingOperation;
  deleteTraining: typeof deleteTrainingOperation;
  getRates: typeof getRatesOperation;
  postRate: typeof postRateOperation;
  getRate: typeof getRateOperation;
  putRate: typeof putRateOperation;
  deleteRate: typeof deleteRateOperation;
  getMonitors: typeof getMonitorsOperation;
  postMonitor: typeof postMonitorOperation;
  getMonitor: typeof getMonitorOperation;
  putMonitor: typeof putMonitorOperation;
  deleteMonitor: typeof deleteMonitorOperation;
  postMonitorFlag: typeof postMonitorFlagOperation;
  getTransactions: typeof getTransactionsOperation;
  postTransaction: typeof postTransactionOperation;
  getTransaction: typeof getTransactionOperation;
  putTransaction: typeof putTransactionOperation;
  deleteTransaction: typeof deleteTransactionOperation;
  getAudits: typeof getAuditsOperation;
  postAudit: typeof postAuditOperation;
  getAudit: typeof getAuditOperation;
  getEnrolments: typeof getEnrolmentsOperation;
  getEnrolment: typeof getEnrolmentOperation;
  putEnrolment: typeof putEnrolmentOperation;
  getEnquiries: typeof getEnquiriesOperation;
  postEnquiry: typeof postEnquiryOperation;
  getEnquiry: typeof getEnquiryOperation;
  putEnquiry: typeof putEnquiryOperation;
  deleteEnquiry: typeof deleteEnquiryOperation;
  postEnquiryConsumer: typeof postEnquiryConsumerOperation;
  postEnquiryConsumerSignature: typeof postEnquiryConsumerSignatureOperation;
  postEnquiryConsumerPreferences: typeof postEnquiryConsumerPreferencesOperation;
  postEnquiryQuote: typeof postEnquiryQuoteOperation;
  postEnquiryJobInfo: typeof postEnquiryJobInfoOperation;
  postEnquiryInterestInCredit: typeof postEnquiryInterestInCreditOperation;
  postEnquiryBudget: typeof postEnquiryBudgetOperation;
  postEnquirySubmit: typeof postEnquirySubmitOperation;
  postEnquiryState: typeof postEnquiryStateOperation;
  postEnquiryConvertJob: typeof postEnquiryConvertJobOperation;
  postEnquiryArchive: typeof postEnquiryArchiveOperation;
  postEnquiryUnarchive: typeof postEnquiryUnarchiveOperation;
  getTags: typeof getTagsOperation;
  postTag: typeof postTagOperation;
  getTag: typeof getTagOperation;
  putTag: typeof putTagOperation;
  deleteTag: typeof deleteTagOperation;
  providerCheckWebhook: typeof providerCheckWebhookOperation;
  providerWebhook: typeof providerWebhookOperation;
  actionAdhoc: typeof actionAdhocOperation;
  postEvent: typeof postEventOperation;
  runner: typeof runnerOperation;
}
